import BaseActionFilter from 'yoda-core-components/lib/helpers/Analytics/BaseActionFilter';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';

export class RewardsActionFilter extends BaseActionFilter {
    getLinkRewardsAccountPL(data) {
        const getMigrationDL = this.updateCommonDigitalData();

        const getLinkRewardsAccountDL = {
            user: getMigrationDL.user,
        };
        /* istanbul ignore next */
        const associateFlag =
            getLinkRewardsAccountDL.user.profile.profileInfo.associateFlag || 'no';
        let rewardsFlag = 'no';
        /* istanbul ignore next */
        let rewardTier =
            TokenProvider.get('DP_REWARDS_TIER') ||
            getLinkRewardsAccountDL.user.profile.profileInfo.rewardsMemberType;
        /* istanbul ignore next */
        if (rewardTier && rewardTier !== 'no rewards account') {
            rewardsFlag = 'yes';
        }
        /* istanbul ignore next */
        if (getLinkRewardsAccountDL.user.profile.profileInfo.mobileOptIn.length === 0) {
            getLinkRewardsAccountDL.user.profile.profileInfo.mobileOptIn.push('no selection');
        }
        /* istanbul ignore next */
        if (!getLinkRewardsAccountDL.user.profile.profileInfo.emailOptIn) {
            getLinkRewardsAccountDL.user.profile.profileInfo.emailOptIn = 'yes';
        }
        if (data.pageName === 'create account group-a') {
            rewardsFlag = 'yes';
            rewardTier = 'base';
        }
        getLinkRewardsAccountDL.user.profile.profileInfo.rewardsFlag = rewardsFlag;
        getLinkRewardsAccountDL.user.profile.profileInfo.rewardsMemberType = rewardTier; // silver gold platinum bronze red pending
        getLinkRewardsAccountDL.user.profile.profileInfo.associateFlag = associateFlag; // yes or no
        delete getLinkRewardsAccountDL.user.profile.profileInfo.storeID;
        return getLinkRewardsAccountDL;
    }
}

export default RewardsActionFilter;
